import { useState, useEffect }      from 'react';
import useTranslate                 from 'app/common/hooks/translate';

let tt;

const LandingContent = _props => {
    const t                                 = useTranslate();

    const [ s, setState ]                   = useState({
        slideIndex        : 0,
    })
    
    useEffect(() => {
        showSlides();
    }, [ s.slideIndex ])

    const plusSlides = n => {
        const newValue = s.slideIndex + n;
        const nSlide = newValue > 3 ? 0 : newValue;

        setState({
            slideIndex: newValue < 0 ? 3 : nSlide
        })
    }

    const getProductUrl = () => {
        const dynamicLinks = [
            "https://simprasuite.com.tr/restoran-rezervasyon-sistemi/?ac=ucretsizdene&utm_source=ssosimprasuite&utm_medium=click",
            "https://simprasuite.com.tr/restoran-otomasyonu/stok-takip-programi/?ac=ucretsizdene&utm_source=ssosimprasuite&utm_medium=click",
            "https://simprasuite.com.tr/restoran-otomasyonu/mobil-raporlama/?ac=ucretsizdene&utm_source=ssosimprasuite&utm_medium=click",
            "https://simprasuite.com.tr/restoran-otomasyonu/qr-menu/?ac=ucretsizdene&utm_source=ssosimprasuite&utm_medium=click",
        ];


        return dynamicLinks[s.slideIndex];
    }

    const showSlides = () => {
        clearTimeout(tt);

        tt = setTimeout(() => {
            setState(prevState => ({
                slideIndex: prevState.slideIndex < 3 ? prevState.slideIndex + 1 : 0
            }))
        }, 7000)
    } 

    const openProductURL = () => {
        window.open(getProductUrl());
    }

    return (
        <div className="slider-container">

            <div className="slider-overlay"></div>

            <div className={ `slide s-1 fade${ s.slideIndex === 0 ? ' active' : '' }` }></div>
            <div className={ `slide s-2 fade${ s.slideIndex === 1 ? ' active' : '' }` }></div>
            <div className={ `slide s-3 fade${ s.slideIndex === 2 ? ' active' : '' }` }></div>
            <div className={ `slide s-4 fade${ s.slideIndex === 3 ? ' active' : '' }` }></div>

            <div className="slider-footer">
                <div className="slider-footer-content">
                    <div className={ `text${ s.slideIndex === 0 ? ' active' : '' }` }>
                        <div className="text-header">
                            <span>{ t("sliderTextHeader1") }</span>
                            <div className="text-header-badge b1">{ t("sliderTextHeaderBadge1") }</div>
                        </div>
                        <div className="text-content">{ t("sliderText1") }</div>
                    </div>
                    <div className={ `text${ s.slideIndex === 1 ? ' active' : '' }` }>
                        <div className="text-header">
                            <span>{ t("sliderTextHeader2") }</span>
                            <div className="text-header-badge b2">{ t("sliderTextHeaderBadge2") }</div>
                        </div>
                        <div className="text-content">{ t("sliderText2") }</div>
                    </div>
                    <div className={ `text${ s.slideIndex === 2 ? ' active' : '' }` }>
                        <div className="text-header">
                            <span>{ t("sliderTextHeader3") }</span>
                            <div className="text-header-badge b3">{ t("sliderTextHeaderBadge3") }</div>
                        </div>
                        <div className="text-content">{ t("sliderText3") }</div>
                    </div>
                    <div className={ `text${ s.slideIndex === 3 ? ' active' : '' }` }>
                        <div className="text-header">
                            <span>{ t("sliderTextHeader4") }</span>
                            <div className="text-header-badge b4">{ t("sliderTextHeaderBadge4") }</div>
                        </div>
                        <div className="text-content">{ t("sliderText4") }</div>
                    </div>
                </div>
                <div className="slider-footer-buttons">
                    { /* eslint-disable-next-line */ }
                    <a href="javascript:void(0)" onClick={ () => openProductURL() } className="learn-more-btn">{ t("learnMore") }</a>
                    <div className="nav-menu">
                        <div className="prev" onClick={ () => plusSlides(-1) }></div>
                        <div className="next" onClick={ () => plusSlides(1) }></div>
                    </div>
                </div>                    
            </div>
        </div>
    )
}

export default LandingContent